import { render } from "./companionTeacher.vue?vue&type=template&id=0106c6f0&scoped=true"
import script from "./companionTeacher.vue?vue&type=script&lang=js"
export * from "./companionTeacher.vue?vue&type=script&lang=js"

import "./companionTeacher.vue?vue&type=style&index=0&id=0106c6f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0106c6f0"]])

export default __exports__